import React, { useEffect, useState } from 'react';
import { Sheet } from '../ui/Sheet.jsx';
import Button from '../ui/Button.jsx';
import Input from '../ui/Input.jsx';
import { useDeleteAccount } from '../context/DeleteAccountContext.jsx';

const CONFIRM_WORD = 'SUPPRIMER';

export default function DeleteAccountSheet() {
  const { isOpen, isSubmitting, error, close, confirmDelete } = useDeleteAccount();
  const [confirmText, setConfirmText] = useState('');

  // Reset the typed confirmation whenever the sheet is (re)opened.
  useEffect(() => {
    if (isOpen) setConfirmText('');
  }, [isOpen]);

  const canDelete = confirmText.trim().toUpperCase() === CONFIRM_WORD && !isSubmitting;

  const onConfirm = async () => {
    if (!canDelete) return;
    try {
      await confirmDelete();
    } catch (e) {
      // error is surfaced via context state
    }
  };

  return (
    <Sheet open={isOpen} onClose={close} title="Supprimer mon compte">
      <div className="space-y-5">
        <div className="rounded-[24px] border border-red-200/70 dark:border-red-900/40 bg-red-50/90 dark:bg-red-900/20 px-4 py-3 text-sm text-red-700 dark:text-red-200 space-y-2">
          <p className="font-semibold">Cette action est définitive et irréversible.</p>
          <p>
            Elle supprime <strong>l'intégralité de votre foyer</strong> : votre compte
            <strong> et celui de votre partenaire</strong>, ainsi que <strong>toutes les réponses</strong>
            du questionnaire. Ces données ne pourront pas être récupérées.
          </p>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-semibold text-ptcm-ink dark:text-gray-100" htmlFor="delete-confirm">
            Pour confirmer, tapez <span className="font-mono">SUPPRIMER</span> ci-dessous.
          </label>
          <Input
            id="delete-confirm"
            type="text"
            autoComplete="off"
            autoCapitalize="characters"
            placeholder="SUPPRIMER"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            disabled={isSubmitting}
          />
        </div>

        {error ? (
          <div className="rounded-2xl border border-red-200/70 bg-red-50/90 px-4 py-3 text-sm text-red-600 dark:bg-red-900/20 dark:text-red-300">
            {error}
          </div>
        ) : null}

        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 pt-1">
          <Button variant="outline" onClick={close} disabled={isSubmitting}>
            Annuler
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={!canDelete}>
            {isSubmitting ? 'Suppression…' : 'Supprimer définitivement'}
          </Button>
        </div>
      </div>
    </Sheet>
  );
}
